export var createApiClientWrapper = function (apiClient, requestConfig, multipartRequestConfig, marketplaceId, timeZone, masterData, uuid, marketplace) { return ({
    apiClient: apiClient,
    requestConfig: requestConfig,
    multipartRequestConfig: multipartRequestConfig,
    marketplaceId: marketplaceId,
    timeZone: timeZone,
    masterData: masterData,
    marketplace: marketplace,
    uuid: uuid
}); };
